import { OtpErrorTypes } from '../typings';
export const PAGE_NAME = {
    IDENTITY_FAILURE: 'identity failure',
    USER_DECLINE: 'user decline'
};
export const OTP_ANALYTICS_PAYLOAD = {
    [OtpErrorTypes.USER_DECLINED]: {
        pageName: PAGE_NAME.IDENTITY_FAILURE,
        errorMessage: OtpErrorTypes.USER_DECLINED
    },
    [OtpErrorTypes.ACCESS_DENIED]: {
        pageName: PAGE_NAME.IDENTITY_FAILURE,
        errorMessage: OtpErrorTypes.ACCESS_DENIED
    }
};
